var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.364 6.34306C18.5592 6.14779 18.5592 5.83121 18.364 5.63595C18.1687 5.44069 17.8521 5.44069 17.6569 5.63595L12 11.2928L6.34315 5.63595C6.14788 5.44069 5.8313 5.44069 5.63604 5.63595C5.44078 5.83121 5.44078 6.14779 5.63604 6.34306L11.2929 11.9999L5.63604 17.6568C5.44078 17.852 5.44078 18.1686 5.63604 18.3639C5.8313 18.5591 6.14789 18.5591 6.34315 18.3639L12 12.707L17.6569 18.3639C17.8521 18.5591 18.1687 18.5591 18.364 18.3639C18.5592 18.1686 18.5592 17.852 18.364 17.6568L12.7071 11.9999L18.364 6.34306Z"}));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;
